module.exports = __webpack_public_path__ + "static/img/091_TO8_1757.bafd266.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/091_TO8_1757.jpg
// module id = CLfJ
// module chunks = 0